import { styled } from '../../Utilities';
import { LinkBase } from './Link.base';
import { getStyles } from './Link.styles';
export var Link = styled(LinkBase, getStyles, undefined, {
    scope: 'Link'
});
//# sourceMappingURL=Link.js.map